import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetricCardHeaderProps {
  icon: LucideIcon;
  title: string;
  subtitle: string;
  actionButton?: React.ReactNode;
}

export function MetricCardHeader({ 
  icon: Icon, 
  title, 
  subtitle, 
  actionButton 
}: MetricCardHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-3">
        {/* Círculo com ícone - estilo premium igual ao "Tempo do Pitch" */}
        <div className="w-12 h-12 rounded-[12px] bg-gradient-to-br from-[#EEF3FF] to-[#E0EAFF] flex items-center justify-center border border-[#B8D0FF]/30">
          <Icon className="h-6 w-6 text-[#3F7CFF]" />
        </div>
        
        {/* Título + Subtítulo */}
        <div className="flex-1">
          <h3 className="text-[15px] font-semibold text-[#0A1A2F] mb-0.5 leading-tight">
            {title}
          </h3>
          <p className="text-[13px] text-[#9CA3AF] font-normal">
            {subtitle}
          </p>
        </div>
      </div>
      
      {/* Ação opcional (ex: botão) */}
      {actionButton && actionButton}
    </div>
  );
}
